import { render } from "./bo-redirection.vue?vue&type=template&id=4cea14bc&scoped=true"
import script from "./bo-redirection.vue?vue&type=script&lang=js"
export * from "./bo-redirection.vue?vue&type=script&lang=js"

import "./bo-redirection.vue?vue&type=style&index=0&id=4cea14bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cea14bc"]])

export default __exports__